module.exports = __webpack_public_path__ + "static/media/RenaultLifeWeb-Light.92c3cb82.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/renault-life/RenaultLifeWeb-Light.eot
// module id = 932
// module chunks = 0